var styles = {"video":"styles_video__1EWEt fit"};

export default styles;
//# sourceMappingURL=styles.css.js.map
